import Hero from "../components/home/Hero";
import StatsStrip from "../components/home/StatsStrip";
import CategoriesBento from "../components/home/CategoriesBento";
import AboutTeaser from "../components/home/AboutTeaser";
import FeaturedProducts from "../components/home/FeaturedProducts";
import CtaStrip from "../components/home/CtaStrip";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <StatsStrip bordered />
      <CategoriesBento />
      <AboutTeaser />
      <FeaturedProducts />
      <CtaStrip />
    </main>
  );
}
